export default __webpack_public_path__ + "static/media/landing-team.02bd442a.svg";